import { get } from 'api';
import { ClientDetail } from 'types/ClientDetail';

export function getClientById(id: number): Promise<ClientDetail> {
  return get(`api/clients/${id}`);
}
